import {
 Alert,
 Box,
 Button,
 CircularProgress,
 FormControl,
 Grid,
 IconButton,
 InputAdornment,
 InputLabel,
 MenuItem,
 Select,
 Slider,
 Snackbar,
 Table,
 TableBody,
 TableCell,
 TableRow,
 TextField,
 Typography
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { auth } from "../../../firebase";
import { AttachFile, Close, PictureAsPdf } from "@mui/icons-material";
import ReactMarkdown from "react-markdown";

const AdminView = () => {
 const zones = [
  "Western Himalayas (J & K, H.P.)",
  "Uttarakhand",
  "Eastern Himalaya (Assam,  W.B., NE  states)",
  "Lower Gangatic Plain  (W.B.)",
  "Middle Gangetic Plain  (Eastern  U.P.)",
  "Bihar",
  "Upper Gangetic  Plain  (Western  U.P.)",
  "Trans Gangetic Plain (Punjab)",
  "Haryana",
  "Eastern  Plateau  &  Hills",
  "Chhatisgarh",
  "Jharkhand",
  "Eastern  Maharashtra (Bhandera region)\n& part of Orissa",
  "Central Plateau & Hills",
  "Madhya  Pradesh",
  "U.P. (Bundel Khand)",
  "Maharashtra",
  "Western Plateau (Maharashtra  and Southern  M.P.)",
  "Southern  Plateau",
  "Andhra  Pradesh",
  "Karnataka",
  "Tamil Nadu",
  "East  Coast  Plains  &  Hills",
  "Orissa",
  "West  Coast  Plains &  Ghats",
  "Kerala",
  "Maharashtra  (Konkan)",
  "Gujarat  Plains  &  Hills",
  "Northern Gujarat",
  "Southern  Gujarat",
  "Western Dry Region (Rajasthan)",
  "Island region (Andaman & Nicobar)"
];
const seasons = ["Spring", "Summer", "Autumn", "Winter"];

const [val, setVal] = React.useState({
  temperature: 25,
  humidity: 50,
  nitrogen: 50,
  potassium: 50,
  phosphorus: 50,
  moisture: 20,
  croptype: "Barley",
  soiltype: "Black",
  modeltype: "v2"
});
const [predicted, setPredictedData] = useState("");
const [predictedId, setPredictedDataId] = useState("");
const [predictedGpt, setPredictedDataGpt] = useState("");
const [openModal, setOpenModal] = useState(false);
const [uploadedFiles, setUploadedFiles] = useState([]);
const [feedback, setFeedBack] = useState({
  rating: 0,
  ratingReason: "",
  confidenceLevel: "",
  suggestedNpk: "",
  AgroZone: "",
  Season: ""
});
const [message, setMessage] = useState("");
const [severity, setSeverity] = useState("success");
const [open, setOpen] = useState(false);

const handleFileUpload = event => {
  const files = Array.from(event.target.files);
  setUploadedFiles(prevFiles => [...prevFiles, ...files]);
};

const handleRemoveFile = index => {
  setUploadedFiles(uploadedFiles.filter((_, i) => i !== index));
};

useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/agri/latest/data`
      );
      if (response.status == 200) {
        setVal(data => ({
          ...data,
          nitrogen: response.data.data[0].nitrogen,
          phosphorus: response.data.data[0].phosphorus,
          potassium: response.data.data[0].potassium,
          temperature: response.data.data[0].temperature,
          humidity: response.data.data[0].humidity
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  fetchData();

  // Optional: Polling every 10 seconds
  // const interval = setInterval(fetchData, 10000);

  // return () => clearInterval(interval); // Cleanup interval on unmount
}, []);

const [loadingApi1, setLoadingApi1] = useState(false);
const [loadingApi2, setLoadingApi2] = useState(false);
const [loadingApi3, setLoadingApi3] = useState(false);
const [predictionshort, setpredictionshort] = useState(false);
const handleSubmitFeedback = async () => {
  setLoadingApi3(true);
  // Prepare FormData
  const formData = new FormData();
  uploadedFiles.forEach(file => formData.append("files", file)); // Ensure backend supports multiple files
  // Append feedback data
  Object.keys(feedback).forEach(key => {
    formData.append(key, feedback[key]);
  });
  formData.append("prediction_id", predictedId);

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/fertilizer/recommendation/expert/feedback`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Replace with your token source
          "Content-Type": "multipart/form-data"
        }
      }
    );
    if (response.data.message == "Prediction created successfully!") {
      setOpenModal(false);
      setMessage(response.data.message);
      setSeverity("success");
      setOpen(true);
    }

    console.log("Upload Success:", response.data);
  } catch (error) {
    setMessage("some problem occured, please try again");
    setSeverity("error");
    setOpen(true);
    console.error("Upload Error:", error);
  } finally {
    setLoadingApi3(false);
    setFeedBack({
      rating: 0,
      ratingReason: "",
      confidenceLevel: "",
      suggestedNpk: "",
      AgroZone: "",
      Season: ""
    });
  }
};

const [currPrompt, setLatestPrompt] = useState("");
const [updatePrompt, setUpdatedPrompt] = useState("");
const [updateMessage, setUpdatedMessage] = useState("");

useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/get/latest/prompt`
      );

      if (response.data.status === "Success") {
        setLatestPrompt(response.data.prompt);
      }
    } catch (err) {
      console.log(err);
    }
  };

  fetchData();

  // Optional: Polling every 10 seconds
  // const interval = setInterval(fetchData, 10000);

  // return () => clearInterval(interval); // Cleanup interval on unmount
}, [updateMessage]);

const handleUpdate = async () => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/update/latest/prompt`,
      {
        prompt: currPrompt
      }
    );

    if (response.data.status === "Success") {
      setUpdatedMessage(response.data.message);
    }
  } catch (err) {
    console.log(err);
  }
};

// const handlePrediction = async () => {
//   const response = await axios.post(
//     `${process.env.REACT_APP_BASE_URL}/agri/fertilizer/recommendation`,
//     {
//       temperature: val.temperature,
//       humidity: val.humidity,
//       nitrogen: val.nitrogen,
//       potassium: val.potassium,
//       phosphorous: val.phosphorus,
//       croptype: val.croptype,
//       soiltype: val.soiltype,
//       moisture: val.moisture,
//     }
//   );
//   if (response.data.status == "success") {
//     setPredictedData(response.data.data);
//   }
// };

function formatRecommendation(jsonData) {
  if (!jsonData.response) {
    return "No recommendation data available.";
  }

  // Split response into sections based on numbered points (1., 2., 3.)
  const sections = jsonData.response.split(/\n\n(?=\d+\.)/);

  // Format each section into markdown-style text
  let formattedText = `### Optimized Recommendations\n\n`;

  sections.forEach(section => {
    formattedText +=
      section
        .replace(/\*\*(.*?)\*\*/g, "**$1**") // Keep bold formatting
        .replace(/-\s/g, "- ") // Normalize list formatting
        .replace(/\n\s+/g, "\n") + "\n\n"; // Remove unnecessary spaces
  });

  return formattedText.trim();
}

const handleClose = (event, reason) => {
  if (reason === "clickaway") {
    return;
  }
  setOpen(false);
};

const handlePrediction = async () => {
  setOpenModal(true);
  try {
    setLoadingApi1(true);
    setLoadingApi2(true);
    // First API Call: Fertilizer Recommendation
    const api1Promise = axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/agri/fertilizer/recommendation/id`,
        {
          temperature: val.temperature,
          humidity: val.humidity,
          nitrogen: val.nitrogen,
          potassium: val.potassium,
          phosphorous: val.phosphorus,
          croptype: val.croptype,
          soiltype: val.soiltype,
          moisture: val.moisture,
          modeltype: val.modeltype
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Replace with your token source
            "Content-Type": "application/json"
          }
        }
      )
      .then(response => {
        if (response.data.status === "success") {
          setPredictedDataId(response.data.id);
          setPredictedData(response.data.data); // UI updates immediately
        }
      })
      .catch(error => {
        console.error(
          "First API failed:",
          error.response && error.response.data
            ? error.response.data
            : error.message
        );
      })
      .finally(() => setLoadingApi1(false));

    // Second API Call: GPT-based Recommendation
    const api2Promise = axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/agri/fertilizer/recommendation/gpt`,
        {
          temperature: val.temperature,
          humidity: val.humidity,
          nitrogen: val.nitrogen,
          potassium: val.potassium,
          phosphorus: val.phosphorus,
          crop_type: val.croptype,
          soil_type: val.soiltype,
          soil_moisture: val.moisture
        }
      )
      .then(response => {
        console.log(formatRecommendation(response.data));
        setPredictedDataGpt(response.data.response);
        console.log("Second API Data:", response.data.response);
      })
      .catch(error => {
        console.error(
          "Second API failed:",
          error.response && error.response.data
            ? error.response.data
            : error.message
        );
      })
      .finally(() => setLoadingApi2(false));

    // Run both APIs in parallel without blocking UI updates
    await Promise.allSettled([api1Promise, api2Promise]);
  } catch (error) {
    console.error("Unexpected error in API calls:", error);
  }
};

const fileInputRef = useRef(null);

const handleChange = e => {
  setVal({ ...val, [e.target.name]: e.target.value });
};

const handleChangeFeedBack = (event, name) => {
  event.persist();
  setFeedBack(prev => ({
    ...prev,
    [name]: event.target.value
  }));
};
  return (
   <>
   <Grid container>
        <Grid item xs={12}>
          <Grid item style={{ marginTop: "3rem", marginBottom: "2.25rem" }}>
            <Typography
              style={{
                color: "rgba(0, 0, 0, 0.80)",
                fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                fontFamily: "Inter, sans-serif",
                fontSize: "1.5rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "1.125rem"
              }}
            >
              Fertilizer Recommendation
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3.87}
          style={{
            borderRadius: "0.75rem",
            marginBottom: "1.75rem",
            marginRight: "1rem",
            border: "1px solid rgba(245, 138, 32, 0.60)",
            background: "#FFF",
            padding: "1rem",
            boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
              <Typography
                variant="h8"
                style={{
                  color: "#181818",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal"
                }}
              >
                Temperature ( °C )
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                marks={[
                  {
                    value: -10,
                    label: ""
                  },
                  {
                    value: val.temperature,
                    label: `${val.temperature}` // Current value label
                  },
                  {
                    value: 50,
                    label: ""
                  }
                ]}
                step={1}
                value={val.temperature}
                name="temperature"
                valueLabelDisplay="off"
                min={-10}
                max={50}
                onChange={e => handleChange(e)}
                sx={{
                  "& .MuiSlider-thumb": {
                    height: "1.5rem", // Thumb height
                    width: "1.5rem", // Thumb width
                    backgroundImage: "url(/thumb.svg)", // Custom image URL
                    backgroundPosition: "center", // Center the image in the thumb
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "none" // Remove the glow effect on hover/focus
                    }
                  },
                  "& .MuiSlider-rail": {
                    height: "1.5rem", // Rail height
                    backgroundColor: "grey", // Non-slided portion color (rail)
                    borderRadius: "0.75rem" // Rounded rail
                  },
                  "& .MuiSlider-track": {
                    height: "1.5rem", // Track height
                    borderRadius: "0.75rem", // Rounded track
                    backgroundColor: "#0E2748" // Active portion color (track)
                  },
                  "& .MuiSlider-markLabel[data-index='0']": {
                    transform: "translateY(6px) translateX(0px)" // Customize min label position
                  },
                  "& .MuiSlider-markLabel[data-index='1']": {
                    transform: "translateY(6px) translateX(-10px)" // Customize max label position
                  },
                  "& .MuiSlider-markLabel[data-index='2']": {
                    transform: "translateY(6px) translateX(-15px)" // Customize max label position
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3.87}
          style={{
            marginBottom: "1.75rem",
            marginRight: "1rem",
            borderRadius: "0.75rem",
            border: "1px solid rgba(245, 138, 32, 0.60)",
            background: "#FFF",
            padding: "1rem",
            boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
              <Typography
                variant="h8"
                style={{
                  color: "#181818",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal"
                }}
              >
                Humidity ( %RH )
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                marks={[
                  {
                    value: 0,
                    label: ""
                  },
                  {
                    value: val.humidity,
                    label: `${val.humidity}` // Current value label
                  },
                  {
                    value: 100,
                    label: ""
                  }
                ]}
                step={1}
                value={val.humidity}
                name="humidity"
                valueLabelDisplay="off"
                min={0}
                max={100}
                onChange={e => handleChange(e)}
                sx={{
                  "& .MuiSlider-thumb": {
                    height: "1.5rem", // Thumb height
                    width: "1.5rem", // Thumb width
                    backgroundImage: "url(/thumb.svg)", // Custom image URL
                    backgroundPosition: "center", // Center the image in the thumb
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "none" // Remove the glow effect on hover/focus
                    }
                  },
                  "& .MuiSlider-rail": {
                    height: "1.5rem", // Rail height
                    backgroundColor: "grey", // Non-slided portion color (rail)
                    borderRadius: "0.75rem" // Rounded rail
                  },
                  "& .MuiSlider-track": {
                    height: "1.5rem", // Track height
                    borderRadius: "0.75rem", // Rounded track
                    backgroundColor: "#0E2748" // Active portion color (track)
                  },
                  "& .MuiSlider-markLabel[data-index='0']": {
                    transform: "translateY(6px) translateX(0px)" // Customize min label position
                  },
                  "& .MuiSlider-markLabel[data-index='1']": {
                    transform: "translateY(6px) translateX(-15px)" // Customize max label position
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3.87}
          style={{
            marginBottom: "1.75rem",
            borderRadius: "0.75rem",
            border: "1px solid rgba(245, 138, 32, 0.60)",
            background: "#FFF",
            padding: "1rem",
            boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
              <Typography
                variant="h8"
                style={{
                  color: "#181818",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal"
                }}
              >
                Moisture
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                marks={[
                  {
                    value: 0,
                    label: ""
                  },
                  {
                    value: val.moisture,
                    label: `${val.moisture}` // Current value label
                  },
                  {
                    value: 100,
                    label: ""
                  }
                ]}
                step={1}
                value={val.moisture}
                name="moisture"
                valueLabelDisplay="off"
                min={0}
                max={100}
                onChange={e => handleChange(e)}
                sx={{
                  "& .MuiSlider-thumb": {
                    height: "1.5rem", // Thumb height
                    width: "1.5rem", // Thumb width
                    backgroundImage: "url(/thumb.svg)", // Custom image URL
                    backgroundPosition: "center", // Center the image in the thumb
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "none" // Remove the glow effect on hover/focus
                    }
                  },
                  "& .MuiSlider-rail": {
                    height: "1.5rem", // Rail height
                    backgroundColor: "grey", // Non-slided portion color (rail)
                    borderRadius: "0.75rem" // Rounded rail
                  },
                  "& .MuiSlider-track": {
                    height: "1.5rem", // Track height
                    borderRadius: "0.75rem", // Rounded track
                    backgroundColor: "#0E2748" // Active portion color (track)
                  },
                  "& .MuiSlider-markLabel[data-index='0']": {
                    transform: "translateY(6px) translateX(0px)" // Customize min label position
                  },
                  "& .MuiSlider-markLabel[data-index='1']": {
                    transform: "translateY(6px) translateX(-15px)" // Customize max label position
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3.87}
          style={{
            borderRadius: "0.75rem",
            marginRight: "1rem",
            border: "1px solid rgba(245, 138, 32, 0.60)",
            background: "#FFF",
            padding: "1rem",
            boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
              <Typography
                variant="h8"
                style={{
                  color: "#181818",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal"
                }}
              >
                Nitrogen ( mg/kg )
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                marks={[
                  {
                    value: 0,
                    label: ""
                  },
                  {
                    value: val.nitrogen,
                    label: `${val.nitrogen}` // Current value label
                  },
                  {
                    value: 200,
                    label: ""
                  }
                ]}
                step={1}
                value={val.nitrogen}
                name="nitrogen"
                valueLabelDisplay="off"
                min={0}
                max={200}
                onChange={e => handleChange(e)}
                sx={{
                  "& .MuiSlider-thumb": {
                    height: "1.5rem", // Thumb height
                    width: "1.5rem", // Thumb width
                    backgroundImage: "url(/thumb.svg)", // Custom image URL
                    backgroundPosition: "center", // Center the image in the thumb
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "none" // Remove the glow effect on hover/focus
                    }
                  },
                  "& .MuiSlider-rail": {
                    height: "1.5rem", // Rail height
                    backgroundColor: "grey", // Non-slided portion color (rail)
                    borderRadius: "0.75rem" // Rounded rail
                  },
                  "& .MuiSlider-track": {
                    height: "1.5rem", // Track height
                    borderRadius: "0.75rem", // Rounded track
                    backgroundColor: "#0E2748" // Active portion color (track)
                  },
                  "& .MuiSlider-markLabel[data-index='0']": {
                    transform: "translateY(6px) translateX(0px)" // Customize min label position
                  },
                  "& .MuiSlider-markLabel[data-index='1']": {
                    transform: "translateY(6px) translateX(-7px)" // Customize max label position
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3.87}
          style={{
            borderRadius: "0.75rem",
            marginRight: "1rem",
            border: "1px solid rgba(245, 138, 32, 0.60)",
            background: "#FFF",
            padding: "1rem",
            boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
              <Typography
                variant="h8"
                style={{
                  color: "#181818",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal"
                }}
              >
                Potassium ( mg/kg )
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                marks={[
                  {
                    value: 0,
                    label: ""
                  },
                  {
                    value: val.potassium,
                    label: `${val.potassium}` // Current value label
                  },
                  {
                    value: 200,
                    label: ""
                  }
                ]}
                step={1}
                value={val.potassium}
                name="potassium"
                valueLabelDisplay="off"
                min={0}
                max={200}
                onChange={e => handleChange(e)}
                sx={{
                  "& .MuiSlider-thumb": {
                    height: "1.5rem", // Thumb height
                    width: "1.5rem", // Thumb width
                    backgroundImage: "url(/thumb.svg)", // Custom image URL
                    backgroundPosition: "center", // Center the image in the thumb
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "none" // Remove the glow effect on hover/focus
                    }
                  },
                  "& .MuiSlider-rail": {
                    height: "1.5rem", // Rail height
                    backgroundColor: "grey", // Non-slided portion color (rail)
                    borderRadius: "0.75rem" // Rounded rail
                  },
                  "& .MuiSlider-track": {
                    height: "1.5rem", // Track height
                    borderRadius: "0.75rem", // Rounded track
                    backgroundColor: "#0E2748" // Active portion color (track)
                  },
                  "& .MuiSlider-markLabel[data-index='0']": {
                    transform: "translateY(6px) translateX(0px)" // Customize min label position
                  },
                  "& .MuiSlider-markLabel[data-index='1']": {
                    transform: "translateY(6px) translateX(-7px)" // Customize max label position
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3.87}
          style={{
            borderRadius: "0.75rem",
            border: "1px solid rgba(245, 138, 32, 0.60)",
            background: "#FFF",
            padding: "1rem",
            boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
              <Typography
                variant="h8"
                style={{
                  color: "#181818",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal"
                }}
              >
                Phosphorus ( mg/kg )
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                marks={[
                  {
                    value: 0,
                    label: ""
                  },
                  {
                    value: val.phosphorus,
                    label: `${val.phosphorus}` // Current value label
                  },
                  {
                    value: 200,
                    label: ""
                  }
                ]}
                step={1}
                value={val.phosphorus}
                valueLabelDisplay="off"
                name="phosphorus"
                min={0}
                max={200}
                onChange={e => handleChange(e)}
                sx={{
                  "& .MuiSlider-thumb": {
                    height: "1.5rem", // Thumb height
                    width: "1.5rem", // Thumb width
                    backgroundImage: "url(/thumb.svg)", // Custom image URL
                    backgroundPosition: "center", // Center the image in the thumb
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "none" // Remove the glow effect on hover/focus
                    }
                  },
                  "& .MuiSlider-rail": {
                    height: "1.5rem", // Rail height
                    backgroundColor: "grey", // Non-slided portion color (rail)
                    borderRadius: "0.75rem" // Rounded rail
                  },
                  "& .MuiSlider-track": {
                    height: "1.5rem", // Track height
                    borderRadius: "0.75rem", // Rounded track
                    backgroundColor: "#0E2748" // Active portion color (track)
                  },
                  "& .MuiSlider-markLabel[data-index='0']": {
                    transform: "translateY(6px) translateX(0px)" // Customize min label position
                  },
                  "& .MuiSlider-markLabel[data-index='1']": {
                    transform: "translateY(6px) translateX(-7px)" // Customize max label position
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: "2rem" }}>
        <Grid item xs={4}>
          <Grid item xs={12} style={{ marginBottom: "0.5rem" }}>
            <Typography
              style={{
                color: "rgba(0, 0, 0, 0.80)",
                fontSize: "1.25rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal"
              }}
            >
              Soil Type
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={val.soiltype}
              name="soiltype"
              style={{ width: "20rem", height: "4.5rem" }}
              onChange={e => handleChange(e)}
            >
              <MenuItem value="Black">Black</MenuItem>
              <MenuItem value="Clayey">Clayey</MenuItem>
              <MenuItem value="Loamy">Loamy</MenuItem>
              <MenuItem value="Red">Red</MenuItem>
              <MenuItem value="Sandy">Sandy</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid item xs={12} style={{ marginBottom: "0.5rem" }}>
            <Typography
              style={{
                color: "rgba(0, 0, 0, 0.80)",
                fontSize: "1.25rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal"
              }}
            >
              Crop Type
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={val.croptype}
              name="croptype"
              style={{ width: "20rem", height: "4.5rem" }}
              onChange={e => handleChange(e)}
            >
              <MenuItem value="Barley">Barley</MenuItem>
              <MenuItem value="Cotton">Cotton</MenuItem>
              <MenuItem value="Ground Nuts">Ground Nuts</MenuItem>
              <MenuItem value="Maize">Maize</MenuItem>
              <MenuItem value="Millets">Millets</MenuItem>
              <MenuItem value="Oil seeds">Oil seeds</MenuItem>
              <MenuItem value="Paddy">Paddy</MenuItem>
              <MenuItem value="Pulses">Pulses</MenuItem>
              <MenuItem value="Sugarcane">Sugarcane</MenuItem>
              <MenuItem value="Tobacco">Tobacco</MenuItem>
              <MenuItem value="Wheat">Wheat</MenuItem>
              <MenuItem value="coffee">coffee</MenuItem>
              <MenuItem value="kidneybeans">kidneybeans</MenuItem>
              <MenuItem value="orange">orange</MenuItem>
              <MenuItem value="pomegranate">pomegranate</MenuItem>
              <MenuItem value="rice">rice</MenuItem>
              <MenuItem value="watermelon">watermelon</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid item xs={12} style={{ marginBottom: "0.5rem" }}>
            <Typography
              style={{
                color: "rgba(0, 0, 0, 0.80)",
                fontSize: "1.25rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal"
              }}
            >
              Model Type
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={val.modeltype}
              name="modeltype"
              style={{ width: "20rem", height: "4.5rem" }}
              onChange={e => handleChange(e)}
            >
              {/* <MenuItem value="v1">V1</MenuItem> */}
              <MenuItem value="v2">V1</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ marginTop: "2.13rem" }}>
          <Button
            variant="contained"
            onClick={handlePrediction}
            style={{
              display: "flex",
              width: "8.75rem",
              padding: "1rem 1.5rem",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.25rem",
              borderRadius: "0.5rem",
              background: "#006BE0"
            }}
          >
            Predict
          </Button>
        </Grid>
       { loadingApi1 ? (
  <Grid
    item
    xs={12}
    style={{
      display: "flex",
      justifyContent: "center",
      marginTop: "3.5rem"
    }}
  >
    <CircularProgress sx={{ color: "#0E2748" }} size={26} />
  </Grid>
) : (
  <>
    {predicted && (
      <>
        <Grid
          item
          xs={12}
          style={{
            marginTop: "3.5rem",
            alignItems: "center",
            display: "flex",
            justifyContent: "center"
          }}
        >
          <Typography
            style={{
              color: "rgba(0, 0, 0, 0.80)",
              fontSize: "1.5rem",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "normal"
            }}
          >
            Prediction:
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center"
          }}
        >
          <Typography
            style={{
              color: "#FFFFFF",
              fontFamily: "Inter",
              fontSize: "1.5rem",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "normal",
              padding: "0.75rem 1.5rem",
              borderRadius: "0.75rem",
              border: "4px solid #F58A20",
              background: "#0E2748"
            }}
          >
            N-P-K : {predicted}
          </Typography>
        </Grid>
      </>
    )}

    <Typography
      variant="h5"
      gutterBottom
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "3.5rem",
        marginBottom: "1.5rem"
      }}
    >
      Fertilizer Recommendation
    </Typography>

    {loadingApi2 ? (
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "3.5rem"
        }}
      >
        <CircularProgress sx={{ color: "#0E2748" }} size={26} />
      </Grid>
    ) : (
      predictedGpt && (
        <div
          style={{
            padding: "1rem",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
          }}
        >
          {/* <Typography
            variant="body1"
            style={{
              fontSize: "1rem",
              lineHeight: "1.5",
              color: "#333",
              whiteSpace: "pre-line"
            }}
          >
            {predictedGpt.replaceAll("###", "\n")}
          </Typography> */}
          <section style={{
                                      fontSize: "1rem",
                                      lineHeight: "1.5",
                                      color: "#333",
                                      whiteSpace: "pre-line"
                                    }}><ReactMarkdown>{predictedGpt}</ReactMarkdown></section>
        </div>
      )
    )}
  </>
)
}
<Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity}>
            {message}
          </Alert>
        </Snackbar>
      </Grid>
   
   </>
  )
}


export default AdminView